module.exports = __webpack_public_path__ + "img/eerduisi-570e3f.png";